module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "point_wrap white_box"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "pointsSumm"
  }, [_c('h4', [_vm._v("购物积分")]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('p', {
    staticClass: "layerCol"
  }, [_vm._v("\n                可用积分："), _c('strong', [_vm._v(_vm._s(_vm.myPointData))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.myCoupon),
      expression: "myCoupon"
    }],
    staticClass: "pointsSumm"
  }, [_c('h4', [_vm._v("我的现金券")]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('p', {
    staticClass: "layerCol"
  }, [_vm._v("\n                可用现金券："), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.myCoupon))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shoppingBonusFlag == 1 || (_vm.shoppingBonusFlag == 2 && +_vm.shoppingBonus > 0)),
      expression: "shoppingBonusFlag == 1 || (shoppingBonusFlag == 2 && +shoppingBonus > 0)"
    }],
    staticClass: "pointsSumm"
  }, [_c('h4', [_vm._v("购物奖励积分")]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('p', {
    staticClass: "layerCol"
  }, [_vm._v("\n                可用购物奖励积分："), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.shoppingBonus))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "24px",
      "background": "#e4393c",
      "color": "#fff",
      "display": "inline-block",
      "padding": "4px 10px",
      "border-radius": "4px",
      "font-size": "13px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.shoppingBonusClick(8601)
      }
    }
  }, [_vm._v("明细")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的积分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('ul', [_c('li', {
    staticClass: "selected"
  }, [_c('a', [_c('span', [_vm._v("我的积分")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d736091e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/shoppingScore.vue
// module id = 1667
// module chunks = 1